export default __webpack_public_path__ + "static/media/G100.7f239e1c.svg";